import { axiosInstanceWithoutErrorModal } from '../assets/utils/axiosInstance';

type PatchClearMessagesResponseType = {
  message: string
};

const patchClearMessages = async (conversation_id: string): Promise<{ data: PatchClearMessagesResponseType }> => {
  
  return new Promise((resolve, reject) => {
    axiosInstanceWithoutErrorModal().patch<PatchClearMessagesResponseType>(`/report-chat/${conversation_id}/messages`).then((response) => {
      resolve(response);
    }).catch(e => {
      reject(e);
    });
  });
};

const reportChatService = {
  patchClearMessages,
};
  
export default reportChatService;